/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI76090ResDataItem {
  
  /** 任务id */
  bizNo?: string;
  
  /** 任务内容 */
  taskTitle?: string;
  
  /** 任务状态 */
  taskStatus?: string;
  
  /** 是否激活 */
  isActivate?: number;
  
  /** 任务开始时间 */
  startTime?: string;
  
  /** 任务持续时间 */
  taskDuration?: number;
  
  /** 岗位 */
  jobPosition?: number;
  
  /** 任务进度0-100 */
  progress?: number;
  
};
    
  



export interface API76090Req {
  
    bizNo: string;
  
};



export type API76090Res = IAPI76090ResDataItem[];


// 接口函数 76090 任务甘特图接口

export interface IUseGetAPI76090Return {
  /** 任务甘特图接口: 接口请求状态 */
  isAPI76090Loading: boolean;
  /** 任务甘特图接口: 接口请求返回数据 */
  dataAPI76090: API76090Res;
  /**  任务甘特图接口: 接口数据请求方法 */
  fetchAPI76090Data: (inputs: API76090Req, config?: YWRequestConfig) => Promise<API76090Res>;
  /** 任务甘特图接口: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76090 = ():IUseGetAPI76090Return => {
  let isMount = true;
  const [isAPI76090Loading, setIsAPI76090Loading] = useState(false);
  const [dataAPI76090, setDataAPI76090] = useState<API76090Res>({} as API76090Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/gantt/view`;

  const fetchAPI76090Data = async (inputs: API76090Req, config?: YWRequestConfig): Promise<API76090Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76090Req>) || {}) as API76090Req;
    
  
    if ( isMount ) {
      setIsAPI76090Loading(true);
    }

    try {
      
      const res: any = await Request.get<API76090Res>(`${basePath}/yoaichat-web/task/instance/gantt/view/${parseParams<API76090Req>(params)}`, {
        loginHost: loginPath,
        ...config
      });
      
      if (isMount) {
        setDataAPI76090(res || {} as API76090Res);
        setIsAPI76090Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76090Loading(false);
      }
      return false as unknown as API76090Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76090Loading,
    dataAPI76090,
    fetchAPI76090Data,
    requestUrl,
  }
}

